import React from "react";
import "./NewsEvents.css";

const NewsEvents_Home = () => {
  const highlights = [];
  const admissions = [];
  const visitors = [];
  const upcomingEvents = [];

  const renderPlaceholderCard = (cardClass, contentClass, title, description) => (
    <div className={`${cardClass} placeholder-card`}>
      <div className={`${contentClass} placeholder-content`}>
        <span className="placeholder-badge">Coming Soon</span>
        <h3>{title}</h3>
        <p>{description}</p>
      </div>
    </div>
  );

  return (
    <div id="news-events" className="news-events-container">
      <h1 className="page-header">News & Events</h1>

      <div className="content-grid">
        {/* Highlights Section */}
        <section className="highlights-section">
          {/* <h2>Research Highlights</h2> */}
          <div className="highlights-list">
            {highlights.length > 0
              ? highlights.map((item, index) => (
                  <div key={index} className="highlight-card">
                    <div className="highlight-content">
                      <span className="highlight-date">{item.date}</span>
                      <h3>{item.title}</h3>
                      <p>{item.description}</p>
                      <a href={item.link} className="read-more">
                        Read More →
                      </a>
                    </div>
                  </div>
                ))
              : renderPlaceholderCard(
                  "highlight-card",
                  "highlight-content",
                  "Research Highlights",
                  "Official research updates will be posted here soon."
                )}
          </div>
        </section>

        {/* Admissions Section */}
        <section className="admissions-section">
          {/* <h2>Admissions & Programss</h2> */}
          <div className="admissions-list">
            {admissions.length > 0
              ? admissions.map((item, index) => (
                  <div key={index} className="admission-card">
                    <div className="admission-content">
                      <span className="admission-date">{item.date}</span>
                      <h3>{item.title}</h3>
                      <p>{item.description}</p>
                      <p className="deadline">Deadline: {item.deadline}</p>
                      <a href={item.link} className="apply-button">
                        Apply Now
                      </a>
                    </div>
                  </div>
                ))
              : renderPlaceholderCard(
                  "admission-card",
                  "admission-content",
                  "Admissions & Programs",
                  "CIP MTech, MSc and PhD admissions are now live. Visit the Admissions page above."
                )}
          </div>
        </section>

        {/* Visitors Section */}
        <section className="visitors-section">
          {/* <h2>Visitors & Seminars</h2> */}
          <div className="visitors-list">
            {visitors.length > 0
              ? visitors.map((visitor, index) => (
                  <div key={index} className="visitor-card">
                    <div className="visitor-content">
                      <span className="visitor-date">{visitor.date}</span>
                      <h3>{visitor.name}</h3>
                      <p className="visitor-title">{visitor.title}</p>
                      <p>{visitor.description}</p>
                      <a href={visitor.link} className="details-button">
                        View Details
                      </a>
                    </div>
                  </div>
                ))
              : renderPlaceholderCard(
                  "visitor-card",
                  "visitor-content",
                  "Visitors & Seminars",
                  "Visitor announcements and seminar details will be shared here soon."
                )}
          </div>
        </section>
      </div>

      {/* Events Section */}
      <section className="events-section home-events-section">
        <h2>Upcoming Events</h2>
        <div className="events-list">
          {upcomingEvents.length > 0
            ? upcomingEvents.map((event, index) => (
                <div key={index} className="event-card home-event-card">
                  <div className="event-content">
                    <div className="event-header">
                      <span className="event-date">{event.date}</span>
                      <span className="registration-status">
                        {event.registration}
                      </span>
                    </div>
                    <h3>{event.title}</h3>
                    <p className="event-location">📍 {event.location}</p>
                    <p>{event.description}</p>
                    <button className="register-button">Learn More</button>
                  </div>
                </div>
              ))
            : renderPlaceholderCard(
                "event-card home-event-card",
                "event-content",
                "Upcoming Events",
                "Event listings are under construction. Official schedules will be posted here soon."
              )}
        </div>
      </section>

      {/* Calendar Section */}
      <section className="calendar-section">
        <h2>Event Calendar</h2>
        <div className="calendar-container">
          <p className="calendar-placeholder">
            Calendar under construction. Official event dates will be posted
            here soon.
          </p>
        </div>
      </section>
    </div>
  );
};

export default NewsEvents_Home;
